// extracted by mini-css-extract-plugin
export default {"templates":"Templates_templates__vNi+s","box":"Templates_box__CF8P2","templatesContainer":"Templates_templatesContainer__V00ys"};